<template>
    <div>
        <el-row style="height:400px;margin-top:8%">
            <el-col :span="24">
                <div style="width:400px;margin:auto;text-align:center">
                    <img width="200px" src="../assets/logo.png">
                    <el-input
                        style="margin-top:20px;"
                        placeholder="请输入账号"
                        prefix-icon="el-icon-user"
                        v-model="login.phone">
                    </el-input>
                    <el-input
                        show-password
                        style="margin-top:20px;"
                        placeholder="请输入密码"
                        prefix-icon="el-icon-key"
                        v-model="login.password">
                    </el-input>
                    <el-button @click="loginAction" class="login">登录</el-button>

                </div>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped>
.login{
    width:100%;
    margin-top:30px;
    height:45px;
    background:linear-gradient(to left bottom,#9765ff,#7698ff);
    font-size: 17px;
    color: white;
}
</style>
<script>

import {accountLogin} from '@/request.js'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
        login:{
            phone:"",
            password:"",
        },
    };
  },
  watch:{
  },
  created() {

  },
  mounted() {

  },
   methods:{
       loginAction(){
           if(this.login.phone==""){
                this.$message.error('请输入手机号');
                return;
           }
            if(this.login.password==""){
               this.$message.error('请输入密码');
               return;
           }
            accountLogin({
                phone:this.login.phone,
                password:this.login.password
            },(res)=>{
                if(res.IsSuccess){
                    localStorage.setItem("outsidertoken",res.Message);
                    localStorage.setItem("outsider",JSON.stringify(res.Result));
                    window.location.reload();
                }else{
                    this.$message.error(res.Message);
                }
            });
       },
   },
}
</script>